export default "__VITE_ASSET__BpDCy5NR__"